"use client";

import useIsMobile from "@/hooks/useIsMobile";
import { motion } from "framer-motion";

export default function SectionReveal({ children, delay = 0 }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <>{children}</>;
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.7,
        ease: "easeOut",
        delay,
      }}
      viewport={{ once: true, margin: "-120px" }}
    >
      {children}
    </motion.div>
  );
}
